module.exports = __webpack_public_path__ + "media/images/metronic/social/quora-c4d9b329088e997e5276c8d1e45d2dc6.png";